import { Component, OnInit } from "@angular/core";
import { Ikr998Data } from "../../interfaces/ert-kr998/ert-kr998Data";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Kr998Service } from "../../services/kr998/kr998.service";
import { ERTUserService } from "../../services/ert-user/ert-user.service";
import { ERTUser } from "../../interfaces/ert-user/ert-user";
import { TrainingType } from "../../services/administration/trainingtypes/trainingtypes";
import { PicklistItem } from "../../shared/picklist/picklist-select.component";
import { IPicklistValuesData } from "../../interfaces/administration/picklistValuesData";
import { PicklistService } from "../../services/administration/picklist/picklist.service";
import { ILoggedUserData } from "../../interfaces/common/loggedUserData";
import { LoggedUserService } from "../../services/common/logged-user.service";

@Component({
  selector: "app-ert-new-kr998",
  templateUrl: "./ert-new-kr998.component.html",
  styleUrl: "./ert-new-kr998.component.css",
})
export class ErtNewKr998Component implements OnInit {
  kr998Form: FormGroup;
  validationMessages: string[] = [];
  instructors: ERTUser[] = [];
  instructorCrew: ERTUser[] = [];
  allInstructors: ERTUser[] = [];
  users: ERTUser[] = [];
  trainingTypes = TrainingType;
  selectedInstructorId: number | null = null;
  selectedCrewItem!: PicklistItem;
  selectedCategoryItem!: PicklistItem;
  currentLoggedInUser: ILoggedUserData;
  constructor(
    private fb: FormBuilder,
    private k998Service: Kr998Service,
    private userService: ERTUserService,
    private pickListsService: PicklistService,
    private loggedInUserService: LoggedUserService,
    private router: Router
  ) {
    this.kr998Form = this.fb.group({
      instructor: ["", Validators.required],
      company: ["", Validators.required],
      startDate: ["", Validators.required],
      startTime: ["", Validators.required],
      endDate: ["", Validators.required],
      endTime: ["", Validators.required],
      location: ["", Validators.required],
      trainingType: ["", Validators.required],
      hours: ["", Validators.required],
      description: ["", Validators.required],
      crew: ["-1", Validators.required],
      category: ["-1", Validators.required],
    });
  }

  ngOnInit(): void {
    this.loggedInUserService.getLoggedUserData().subscribe((user) => {
      const facilityId = Number(user?.facilityId) || 1;
      this.userService.getUsersAndInstructors(facilityId).subscribe((data) => {
        this.allInstructors = data.instructors;
        this.instructors = data.instructors
          .filter(
            (user) =>
              !user.picklistValues.some(
                (picklist) => picklist.value === "Inactive"
              )
          )
          .sort((a, b) => {
            return a.fullName
              .toLowerCase()
              .localeCompare(b.fullName.toLowerCase());
          });
      });
    });

    this.loggedInUserService.getLoggedUserData().subscribe((user) => {
      this.currentLoggedInUser = user;
    });
  }

  onCrewSelected(item: PicklistItem) {
    this.selectedCrewItem = item;
    this.getUsersBySelectedCrew(item.id);
  }

  onCategorySelected(item: PicklistItem) {
    this.selectedCategoryItem = item;
  }

  getTrainingTypeKeys(): string[] {
    return Object.keys(this.trainingTypes).filter(
      (key) => !isNaN(Number(this.trainingTypes[key]))
    );
  }

  getUsersBySelectedCrew(crewValue: string) {
    this.userService.getUsersByCrewValueId(crewValue).subscribe((data) => {
      this.instructorCrew = data.filter((user) => user.isInstructor);
      this.users = data.filter((user) => !user.isInstructor);
    });
  }

  onSubmit() {
    this.validationMessages = this.k998Service.validate(this.kr998Form);
    if (this.validationMessages.length > 0) {
      return;
    }
    if (this.kr998Form.valid) {
      const crewValue = this.kr998Form.get("crew")?.value;
      const categoryValue = this.kr998Form.get("category")?.value;

      const crew: IPicklistValuesData = {
        id: crewValue,
        value: this.selectedCrewItem?.text,
        picklistFieldId: this.selectedCrewItem?.fieldId,
        facilityId: Number(this.currentLoggedInUser?.facilityId) || 1,
      };

      const category: IPicklistValuesData = {
        id: categoryValue,
        value: this.selectedCategoryItem?.text,
        picklistFieldId: this.selectedCategoryItem?.fieldId,
        facilityId: Number(this.currentLoggedInUser?.facilityId) || 1,
      };

      const formValues = this.kr998Form.value;
      const kr998ErtUsers = [];

      if (formValues.instructor) {
        kr998ErtUsers.push({
          userErtId: formValues.instructor,
          kr998Id: 0,
          isInstructior: true,
          kr998DetailsId: 0,
          instructorAtTimeOfClass: true,
          createdDate: new Date().toISOString(),
          hours: 0,
          attendanceType: 0,
          attendanceStatus: 0,
          userErt: null,
          kr998: null,
        });
      }

      this.allInstructors.forEach((instructor) => {
        const alreadyExists = kr998ErtUsers.some(
          (user) => String(user.userErtId) === String(instructor.id)
        );
        if (!alreadyExists) {
          kr998ErtUsers.push({
            userErtId: instructor.id,
            kr998Id: 0,
            isInstructior: true,
            kr998DetailsId: 0,
            instructorAtTimeOfClass: true,
            createdDate: null,
            hours: 0,
            attendanceType: 0,
            attendanceStatus: 0,
            userErt: null,
            kr998: null,
          });
        }
      });

      this.instructorCrew.forEach((instructor) => {
        const alreadyExists = kr998ErtUsers.some(
          (user) => String(user.userErtId) === String(instructor.id)
        );
        if (
          !alreadyExists &&
          String(instructor.id) !== String(formValues.instructor)
        ) {
          kr998ErtUsers.push({
            userErtId: instructor.id,
            kr998Id: 0,
            isInstructior: true,
            kr998DetailsId: 0,
            instructorAtTimeOfClass: true,
            createdDate: null,
            hours: 0,
            attendanceType: 0,
            attendanceStatus: 0,
            userErt: null,
            kr998: null,
          });
        }
      });

      this.users.forEach((user) => {
        kr998ErtUsers.push({
          userErtId: user.id,
          kr998Id: 0,
          isInstructior: false,
          kr998DetailsId: 0,
          instructorAtTimeOfClass: false,
          createdDate: null,
          hours: 0,
          attendanceType: 0,
          attendanceStatus: 0,
          userErt: null,
          kr998: null,
        });
      });

      const newKr998: Ikr998Data = {
        id: 0,
        facilityId: Number(this.currentLoggedInUser?.facilityId) || 1,
        kr998ErtUsers: kr998ErtUsers,
        startDateTime: `${formValues.startDate}T${formValues.startTime}:00.000Z`,
        endDateTime: `${formValues.endDate}T${formValues.endTime}:00.000Z`,
        hours: formValues.hours || 0,
        company: formValues.company,
        location: formValues.location,
        description: formValues.description,
        trainingType: formValues.trainingType,
        crewId: crewValue,
        categoryId: categoryValue,
        picklistValues: [crew, category],
        createdById: this.currentLoggedInUser?.id,
        modifiedById: null,
      };

      this.k998Service.createKr998(newKr998).subscribe((data) => {
        //this.router.navigate(["/ert-kr998/ert-new-kr998-add-crew", data.id]);
        this.router.navigate(["/ert-kr998/ert-kr998-view", data.id]);
      });
    } else {
      this.kr998Form.markAllAsTouched();
    }
  }
  onCancel(): void {
    this.router.navigate(["/ert-kr998"]);
  }
}
